var map = {
	"./mts-main-products-boards.mp4": 2344,
	"./mts-main-products-chats.mp4": 2345,
	"./mts-main-products-comdi.mp4": 2346,
	"./mts-main-products-courses.mp4": 2347,
	"./mts-main-products-equipment.mp4": 2348,
	"./mts-main-products-forms.mp4": 2349,
	"./mts-main-products-meetings.mp4": 2350,
	"./mts-main-products-webinars.mp4": 2351,
	"./mts-products-chats-account-management.mp4": 2352,
	"./mts-products-chats-adding-employees.mp4": 2353,
	"./mts-products-chats-ai-assistant.mp4": 2354,
	"./mts-products-chats-appointment-moderators.mp4": 2355,
	"./mts-products-chats-chats-and-channels.mp4": 2356,
	"./mts-products-chats-distribution-groups.mp4": 2357,
	"./mts-products-chats-favorite-features.mp4": 2358,
	"./mts-products-chats-in-platform.mp4": 1543,
	"./mts-products-chats-one-click-call.mp4": 2359,
	"./mts-products-chats-promo-mobile.mp4": 1544,
	"./mts-products-chats-promo.mp4": 2297,
	"./mts-products-comdi.mp4": 1539,
	"./tab-intelligence-video.mp4": 1545,
	"./webinar-meetings.mp4": 2360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1242;